import { render, staticRenderFns } from "./RecentListPage.vue?vue&type=template&id=3d080786&scoped=true"
import script from "./RecentListPage.vue?vue&type=script&lang=js"
export * from "./RecentListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d080786",
  null
  
)

export default component.exports